export default "__VITE_ASSET__ed6f4a5b__"